import { wrapper } from "@/redux/Store";

import OfferPage from "@/containers/OfferPage";
import { renderMetaData } from "@/utils";
const Offer = () => {
  const metaData = {
    title: "Shyft privacy policy",
    description: "Shyft privacy policy",
  };

  const metaTags = renderMetaData(metaData);
  return (
    <>
      {metaTags}
      <main>
        <OfferPage />
      </main>
    </>
  );
};

export default Offer;

export const getStaticProps = wrapper.getStaticProps(() => async () => {
  return {
    props: {},
    revalidate: 60 * 60 * 24 * 30, // revalidate in 15 days
  };
});
